import { useRouter } from "next/router";
import { textTermsCondition } from "../../src/components/MockData/MockData";
import ClientLayout from "../../src/layouts/client/ClientLayout"
import MetaHeader from "../../src/components/MetaHeader";
import { textConfig } from "../../constants/textLang";

const TermsAndCondition = () => {
    const router = useRouter()
    const { locale } = router
    return (
        <ClientLayout style={{ backgroundColor: 'black' }}>
            <div className="terms-and-condition-content">
                <div className="content-footer-wrapper">
                    <div className="header-title">
                        <h1>{textTermsCondition[locale].head_title}</h1>
                    </div>
                    <div className="main-content-text">
                        <div className="text-top">
                            <p>{textTermsCondition[locale].one_title}</p>
                        </div>
                        <div className="text-detail">
                            <ul>
                                <li>{textTermsCondition[locale].one_dot_text}</li>
                            </ul>
                        </div>
                        <div className="text-detail">
                            <p>{textTermsCondition[locale].two_title}</p>
                        </div>
                        <div className="text-detail">
                            <p>{textTermsCondition[locale].two_one_title}</p>
                        </div>
                        <div className="text-detail">
                            <p>{textTermsCondition[locale].two_two_title}</p>
                        </div>
                        <div className="text-detail">
                            <p>{textTermsCondition[locale].two_three_title}</p>
                        </div>
                        <div className="text-detail">
                            <ul>
                                <li>{textTermsCondition[locale].two_dot_text}</li>
                            </ul>
                        </div>
                        <div className="text-detail">
                            <p>{textTermsCondition[locale].two_four_title}</p>
                        </div>
                        <div className="text-detail">
                            <ul>
                                <li>{textTermsCondition[locale].three_dot_text}</li>
                            </ul>
                        </div>
                        <div className="table-data">
                            <table className="table-one">
                                <tbody>
                                    {textTermsCondition[locale].text_table.map((itemTable, indexTable) => (
                                        <tr key={indexTable}>
                                            <td>{itemTable.one_desc}</td>
                                            <td>{itemTable.two_desc}</td>
                                            <td>{itemTable.three_desc}</td>
                                            <td>{itemTable.four_desc}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="text-note">
                            <p>{textTermsCondition[locale].note}</p>
                        </div>
                        <div className="text">
                            {textTermsCondition[locale].text_five_title.map((itemFive, indexFive) => (
                                <div key={indexFive}>
                                    <p>{itemFive.normal_text}</p>
                                    {itemFive.note_text && <p className="text-note-red">{itemFive.note_text}</p>}
                                </div>
                            ))}
                        </div>
                        <div className="text-detail">
                            <p>{textTermsCondition[locale].title_text_three}</p>
                        </div>
                        <div className="text">
                            <p>{textTermsCondition[locale].desc_text_three}</p>
                        </div>
                        <div className="text-detail">
                            <p>{textTermsCondition[locale].title_text_four}</p>
                        </div>
                        <div className="text">
                            <p>{textTermsCondition[locale].desc_text_four}</p>
                        </div>
                        <div className="text-detail">
                            <p>{textTermsCondition[locale].title_text_five}</p>
                        </div>
                        <div className="text">
                            {textTermsCondition[locale].text_dot_five.map((itemDotFive, indexDotFive) => (
                                <div className="text-detail" key={indexDotFive}>
                                    <p>{itemDotFive}</p>
                                </div>
                            ))}
                        </div>
                        <div className="text-detail">
                            <p>{textTermsCondition[locale].title_text_six}</p>
                        </div>
                        <div className="text">
                            {textTermsCondition[locale].text_dot_six.map((itemDotSix, indexDotSix) => (
                                <div className="text-detail" key={indexDotSix}>
                                    <p>{itemDotSix}</p>
                                </div>
                            ))}
                        </div>
                        <div className="text-detail">
                            <p>{textTermsCondition[locale].title_text_seven}</p>
                        </div>
                        <div className="text-detail">
                            {textTermsCondition[locale].text_dot_seven.map((itemDotSeven, indexDotSeven) => (
                                <div className="text-detail" key={indexDotSeven}>
                                    <p>{itemDotSeven}</p>
                                </div>
                            ))}
                        </div>
                        <div className="text-bottom">
                            <p>{textTermsCondition[locale].last_text}</p>
                        </div>
                    </div>
                </div>
            </div>
        </ClientLayout>
    )
}

export const getStaticProps = async (ctx) => {
    const { locale } = ctx
    const meta = {
        title: textConfig[locale]?.title_terms_and_condition,
        keywords: textConfig[locale]?.text_keyword,
        description: 'Luxury29 Car Rental Terms And Condition Page',
        image: 'main-pic.jpeg'
    };

    return {
        props: { meta },
    };
};

export default MetaHeader(TermsAndCondition);